export const pageConfig = {
  metadata: {
    title: "DigCat ORR Agent",
    description: "Next.js chatbot template using the AI SDK.",
    metadataBase: "https://chat.vercel.ai",
  },
  brand: {
    name: "DigCat",
    productName: "ORR Agent",
    poweredByLabel: "Powered by",
    logo: {
      ariaLabel: "DigCat",
      imageSrc: `${process.env.NEXT_PUBLIC_BASE_PATH ?? ""}/digcat.jpg`,
      imageAlt: "DigCat",
      monogram: "D",
    },
  },
  auth: {
    login: {
      title: "Welcome to DigCat ORR Agent",
      subtitle: "Sign in to your account to continue",
      submitLabel: "Sign in",
      switchPrompt: "No account? ",
      switchLabel: "Sign up",
    },
    register: {
      title: "Create account for DigCat ORR Agent",
      subtitle: "Enter your invite code to create an account",
      submitLabel: "Sign up",
      switchPrompt: "Have an account? ",
      switchLabel: "Sign in",
    },
    notifications: {
      invalidCredentials: "Invalid credentials!",
      accountExists: "Account already exists!",
      createAccountFailed: "Failed to create account!",
      invalidInviteCode: "Invalid invite code!",
      validationFailed: "Failed validating your submission!",
      accountCreated: "Account created!",
    },
    form: {
      emailLabel: "Email",
      emailPlaceholder: "you@someo.ne",
      passwordLabel: "Password",
      passwordPlaceholder: "********",
      inviteCodeLabel: "Invite code",
      inviteCodePlaceholder: "Enter your invite code",
    },
  },
  chat: {
    greetingTitle: "What can I help with catalyst design?",
    greetingSubtitle: "Ask a question about catalyst design, and I'll do my best to assist you.",
    askPlaceholder: "Ask anything...",
    editPlaceholder: "Edit your message...",
    signedOutPlaceholder: "Sign in to ask anything...",
    thinkingLabel: "Thinking...",
    signInRequiredMessage: "Please sign in before starting a chat.",
    modelSearchPlaceholder: "Search models...",
    renameUnavailableMessage: "Rename is available from the sidebar chat menu.",
    editingMessageLabel: "Editing message",
    cancelLabel: "Cancel",
    deleteChatPrompt: "Delete this chat?",
    deleteChatActionLabel: "Delete",
    deleteChatSuccess: "Chat deleted",
    deleteAllChatsPrompt: "Delete all chats?",
    deleteAllChatsActionLabel: "Delete all",
    deleteAllChatsSuccess: "All chats deleted",
    uploadFileError: "Failed to upload file, please try again!",
    uploadFilesError: "Failed to upload files",
    uploadPastedImagesError: "Failed to upload pasted image(s)",
    sidebarTooltip: "Chatbot",
    openSidebarLabel: "Open sidebar",
    newChatTooltip: "New Chat",
    newChatLabel: "New chat",
    defaultChatTitle: "New chat",
    deleteAllChatsTooltip: "Delete All Chats",
    deleteAllChatsLabel: "Delete all",
    deleteAllChatsDialogTitle: "Delete all chats?",
    deleteAllChatsDialogDescription:
      "This action cannot be undone. This will permanently delete all your chats and remove them from our servers.",
    deleteAllChatsConfirmLabel: "Delete All",
    slashCommands: {
      newDescription: "Start a new chat",
      clearDescription: "Clear current chat",
      renameDescription: "Rename current chat",
      modelDescription: "Change the AI model",
      themeDescription: "Toggle dark/light mode",
      deleteDescription: "Delete current chat",
      purgeDescription: "Delete all chats",
    },
    suggestions: [
      "Analyze and rank ORR catalyst data for alkaline media",
      "Design a non-PGM ORR catalyst with Fe-N-C active sites",
      "Suggest dopants and supports for improving ORR durability",
      "Plan a synthesis and validation process for an ORR catalyst",
    ],
  },
} as const;
